import React from "react";
import { Box, Button, Typography } from "@mui/material";
import side_img_1 from "../../assets/images/side_img_1.svg";
import side_img_2 from "../../assets/images/side_img_2.svg";
import side_img_3 from "../../assets/images/side_img_3.svg";
import front_img_1 from "../../assets/images/front_img_1.svg";
import front_img_2 from "../../assets/images/front_img_2.svg";
import front_img_3 from "../../assets/images/front_img_3.svg";
import CustomDialog from "../../components/layouts/common/CustomDialog";

const InstructionModal = ({ onReady }) => {
  return (
    <CustomDialog id={"instruction-modal"}>
    <Box
      sx={{
        width: "100%",
        maxWidth: 700,
        p: 4,
        textAlign: "center",
        // backgroundColor: "white",
        // boxShadow: "0px 0px 20px rgba(0,0,0,0.2)",
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 3 }}>
        Face Positions
      </Typography>

  
      {/* FRONT PROFILE INSTRUCTIONS */}
      <Typography
        variant="h6"
        sx={{ fontWeight: 500, color: "#333", textAlign: "left", mb: 1 }}
      >
        Front Profile Instructions
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 2,
          mb: 4,
        }}
      >
        {[front_img_1, front_img_2, front_img_3].map((imgSrc, idx) => (
          <Box
            key={`front-${idx}`}
            sx={{
              width: "100%",
              height: 150,
              backgroundColor: "#f9f9f9",
              borderRadius: 2,
              border: "1px solid #ddd",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <img src={imgSrc} alt={`Front ${idx + 1}`}  />
          </Box>
        ))}
      </Box>
    {/* SIDE PROFILE INSTRUCTIONS */}
    <Typography
        variant="h6"
        sx={{ fontWeight: 500, color: "#333", textAlign: "left", mb: 1 }}
      >
        Side Profile Instructions
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 2,
          mb: 4,
        }}
      >
        {[side_img_1, side_img_2, side_img_3].map((imgSrc, idx) => (
          <Box
            key={`side-${idx}`}
            sx={{
              width: "100%",
              height: 140,
              backgroundColor: "#f9f9f9",
              borderRadius: 2,
              border: "1px solid #ddd",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "hidden",
            }}
          >
            <img src={imgSrc} alt={`Side ${idx + 1}`} />
          </Box>
        ))}
      </Box>

      {/* READY Button */}
      <Button
        variant="contained"
        onClick={onReady}
        sx={{
          backgroundColor: "#00c853",
          color: "#fff",
          px: 6,
          py: 1.5,
          fontSize: "1.1rem",
          fontWeight: "bold",
          borderRadius: 2,
          "&:hover": { backgroundColor: "#00b248" },
        }}
      >
        READY
      </Button>
    </Box>
    </CustomDialog>
  );
};

export default InstructionModal;
